import { render } from "./UserIcon.vue?vue&type=template&id=e72fab3a"
const script = {}

import "./UserIcon.vue?vue&type=style&index=0&id=e72fab3a&lang=css"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__